






















































































import mixins from 'vue-typed-mixins';
import HumanResourcesUtils, {
  HumanResourcePlan,
} from '@/utils/HumanResourcesUtils';
import cloneDeep from 'lodash.clonedeep';
import { SubOrganization } from '@/utils/SubOrganizationUtils';
import deepEqual from 'deep-equal';
import { PointsOfService } from '@/utils/PointsOfServiceUtils';
import DataSetUtils, { DataSet, DataSetContent } from '@/utils/DataSetUtils';
import MultipleChoiceDataSetGuidelineSelectVue from './multiplechoicedataset/MultipleChoiceDataSetGuidelineSelect.vue';
import humanresourcetypes, { getComponents,} from './humanresources/humanresourcestypes';
import { ReportNode, QuestionData, ReportContext } from '@/utils/ReportUtils';
import { Question, SurveyParticipation } from '@/utils/SurveyUtils';
export default mixins().extend({
  components: {
    MultipleChoiceDataSetGuidelineSelect: MultipleChoiceDataSetGuidelineSelectVue,
    ...(getComponents() as any),
  },

  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },

    context: {
      type: Object as () => ReportContext,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },

    suborganizationLabel(): string {
      return (
        this.$translate(this.context.survey?.languageobjects?.suborg) ||
        this.$tc('model.survey.suborg')
      );
    },

    pointsofserviceLabel(): string {
      return (
        this.$translate(this.context.survey?.languageobjects?.pointofservice) ||
        this.$tc('model.survey.pointsofservice')
      );
    },

    headers(): any[] {
      this.value.item.options.source;

      // TODO: what to call column for source? make option?

      return [
        this.value.item.options.source === 'sub_organization'
          ? { text: this.suborganizationLabel, value: 'suborganization.name' }
          : {
              text: this.pointsofserviceLabel,
              value: 'pointsofservice.name',
            },
        ...(this.value.item.options.department.active
          ? [
              {
                text: this.$translate(this.value.item.options.department.label),
                value: 'department',
              },
            ]
          : []),
        ...(this.value.item.options.position.active
          ? [
              {
                text: this.$translate(this.value.item.options.position.label),
                value: 'position',
              },
            ]
          : []),
      ];
    },

    suborgsOptions(): any {
      return this.context.suborganizations?.map((suborg: SubOrganization) => ({
        text: this.$translate(suborg.name),
        value: suborg,
      }));
    },

    pointsofserviceOptions(): any {
      return this.context.pointsofservices?.map(
        (pointsofservice: PointsOfService) => ({
          text: this.$translate(pointsofservice.name),
          value: pointsofservice,
        })
      );
    },

    departments(): HumanResourcePlan['department'][] {
      return this.items?.map((item) => item.department) || [];
    },
  },

  data(): {
    items?: HumanResourcePlan[];
    pristine?: HumanResourcePlan[];
    datasetcontent?: DataSetContent<void>[];
    removeList: HumanResourcePlan[];
    modal: {
      state: 'edit' | 'create';
      item?: HumanResourcePlan;
      pristine?: HumanResourcePlan;
    };
  } {
    return {
      items: undefined,
      pristine: undefined,
      datasetcontent: undefined,
      removeList: [],
      modal: {
        state: 'create',
        item: undefined,
        pristine: undefined,
      },
    };
  },

  async mounted() {
    this.loadDataSets(); // async
    try {
      this.$alert.hide('mount');
      if (!this.context.mode.includes('preview')) {
        this.items = await HumanResourcesUtils.api.list({
          questionid: this.value.item.id as number,
          surveyparticipationid: this.context.surveyParticipation?.id as number,
        });
      } else {
        this.items = [];
      }
      this.pristine = cloneDeep(this.items);
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    create() {
      if (!this.readonly) {
        (this.$refs.modal as any).open();
        this.modal = {
          pristine: undefined,
          state: 'create',
          item: {
            suborganization: undefined,
            pointsofservice: undefined,
            surveyparticipation: {id: this.context.surveyParticipation?.id as number},
            question: {id: this.value.item.id},
            department: undefined,
            position: undefined,
            positioncount: undefined,
          },
        };
      }
    },

    edit(item: any) {
      if (!this.readonly) {
        this.modal = {
          pristine: item,
          state: 'edit',
          item: {
            ...cloneDeep(item),
            suborganization:
              this.value.item.options.source === 'sub_organization'
                ? this.context.suborganizations?.find(
                    (suborg: SubOrganization) =>
                      suborg.id === item?.suborganization?.id
                  )
                : null,
            pointsofservice:
              this.value.item.options.source === 'points_of_service'
                ? this.context.pointsofservices?.find(
                    (pointsofservice: PointsOfService) =>
                      pointsofservice.id === item?.pointsofservice?.id
                  )
                : null,
          },
        };
        (this.$refs.modal as any).open();
      }
    },

    async remove(item: any) {
      if (!this.readonly) {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [
              this.$tc('model.question.options.human_resources.resource'),
            ])
            .toString(),
          async () => {
            if (this.items) {
              if (item.id) {
                this.removeList.push(item);
              }
              const index = this.items.findIndex((value) => value === item);
              if (index >= 0) {
                this.items?.splice(index, 1);
              }
              this.handleChange();
            }
          }
        );
      }
    },

    async submit(resolve: any) {
      /**
       * setTimeout required because of a bug with the department v-combobox
       * https://github.com/vuetifyjs/vuetify/issues/4679
       * The combobox only updates the v-model value on the blur event (when the text field is clicked away from).
       * This doesn't trigger before this submit event is fired if the submit button is clicked immediately.
       * setTimeout gives enough time for the blur event to fire before the submit actually happens.
       */
      setTimeout(() => {
        if (this.items && this.modal.pristine && this.modal.item) {
          const index = this.items.findIndex(
            (item) => item === this.modal.pristine
          );
          if (index >= 0) {
            this.items[index] = this.modal.item;
          }
          this.items = Array.from(this.items);
        } else {
          this.items?.push(this.modal.item as HumanResourcePlan);
        }
        this.modal.item = undefined;
        this.handleChange();
        resolve();
      }, 100);
    },

    cancel(resolve: any) {
      this.modal.item = undefined;
      resolve();
    },

    async before() {
      if (!this.context.mode.includes('preview')) {
        const addList: HumanResourcePlan[] = [];
        const updateList: HumanResourcePlan[] = [];

        this.items?.forEach((hrplan) => {
          if (hrplan.id) {
            updateList.push(hrplan);
          } else {
            addList.push(hrplan);
          }
        });

        const resp = await Promise.all([
          addList.length > 0 ? HumanResourcesUtils.api.add(addList) : undefined,
          ...(updateList.map((hrplan) => {
            const pristine = this.pristine?.find(
              (pristine) => pristine.id === hrplan.id
            );
            if (!deepEqual(pristine, hrplan)) {
              return HumanResourcesUtils.api.update(hrplan);
            }
          }) as any[]),
          ...(this.removeList.map((hrplan) =>
            HumanResourcesUtils.api.remove(hrplan.id as number)
          ) as any[]),
        ]);

        if (addList.length > 0) {
          // update the id's for any answers so they will be updated on the next submit
          addList.forEach((hrplan, index) => {
            hrplan.id = resp[0][index].id;
          });
        }
      }

      this.items = Array.from(this.items as HumanResourcePlan[]);
      this.pristine = cloneDeep(this.items);
      this.removeList = [];
    },

    handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        let completeness = 0;
        if (this.items && this.items?.length > 0) {
          completeness++;
        }
        this.value.data.participation.completeness = completeness / 1;
      }
    },

    async loadDataSets() {
      if(! this.value.item.options.position?.dataset?.key)
        return;
      try {
        this.$alert.hide('mounted');
        this.datasetcontent = await DataSetUtils.api.content.list(
          this.value.item.options.position.dataset.key,
          { surveyparticipationid: this.context.surveyParticipation?.id }
        );
      } catch (error) {
        this.$alert.show('mounted', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
